interface ProductReference {
  requested_product?: string | null;
  requested_product_internal?: {
    id?: string;
  } | null;
}

export function getTemplateProductIdentifier(product: ProductReference) {
  return (
    product.requested_product_internal?.id ||
    product.requested_product ||
    undefined
  );
}

export function getTemplateSharing(template: {
  users: Array<{ username: string }>;
  facility_organizations: Array<{ id: string }>;
}) {
  return {
    users: template.users.map((user) => user.username),
    facility_organizations: template.facility_organizations.map(
      (organization) => organization.id,
    ),
  };
}
export async function hydrateTemplateProduct<T>(
  identifier: string | null | undefined,
  retrieve: (identifier: string) => Promise<T>,
) {
  if (!identifier) {
    return undefined;
  }
  try {
    return await retrieve(identifier);
  } catch {
    return undefined;
  }
}
export type ResponseTemplateKeyFilter =
  | "medication_request"
  | "activity_definition"
  | "questionnaire";

const BUILT_IN_TEMPLATE_QUESTIONNAIRES = new Set([
  "medication_request",
  "service_request",
]);

export function getTemplateQuestionnaireSlug(questionnaireSlug?: string) {
  if (
    !questionnaireSlug ||
    BUILT_IN_TEMPLATE_QUESTIONNAIRES.has(questionnaireSlug)
  ) {
    return undefined;
  }
  return questionnaireSlug;
}

export function getResponseTemplateQueryKey(
  questionnaireSlug: string | undefined,
  keyFilter: ResponseTemplateKeyFilter,
) {
  return [
    "questionnaireResponseTemplates",
    questionnaireSlug,
    keyFilter,
  ] as const;
}
